module.exports = __webpack_public_path__ + "img/thumb_08.dd501bd3.jpg";